import { apiAuth, apiResponseType } from ".";

export const getUnityDistributionBalances = (unityId: number) => {
  return apiAuth.get(
    `distributions/unity-balances?unity_id=${unityId}`
  ) as apiResponseType;
};

/**
 * Busca dados simplificados de distribuição entre unidades com balanços por produto
 * @param {string} contest_id - ID do concurso
 * @param {number} page - Página atual
 * @param {number} per_page - Itens por página
 * @param {string} product_name - Filtro por nome do produto (ex: B200)
 * @returns {apiResponseType} Resposta da API com produtos e balanços das unidades para distribuição entre unidades
 */
export const getUnityToUnityBalancesSimplified = (
  contest_id: string,
  page?: number,
  per_page?: number,
  product_name?: string
): apiResponseType => {
  const params = new URLSearchParams();
  if (page) params.append("page", String(page));
  if (per_page) params.append("per_page", String(per_page));
  if (product_name) params.append("product_name", product_name);
  const queryString = params.toString();
  return apiAuth.get(`/distributions/unity-balances/between/show/${contest_id}${queryString ? `?${queryString}` : ""}`);
};

export const storeDistributionsUnityToUnity = (
  contestId: string,
  data: {
    contest_id: number;
    lottery_id: number;
    contest_product_classification_id: number;
    from_unity_id: number;
    unities: { id: number; quota_quantity: number }[];
  }
) => {
  console.log(contestId);
  return apiAuth.post(
    `distributions/unity-balances/distribution-between-unities`,
    data
  ) as apiResponseType;
};

export const storeDistributionsUnityToUnityWithFiles = (
  data: FormData
) => {
  return apiAuth.post(
    `distributions/unity-balances/distribution-between-unities`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  ) as apiResponseType;
};